'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAxisOptions = exports.getTimeProc = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _dateFns = require('date-fns');

var _dateFns2 = _interopRequireDefault(_dateFns);

var _is_monday = require('date-fns/is_monday');

var _is_monday2 = _interopRequireDefault(_is_monday);

var _is_tuesday = require('date-fns/is_tuesday');

var _is_tuesday2 = _interopRequireDefault(_is_tuesday);

var _is_wednesday = require('date-fns/is_wednesday');

var _is_wednesday2 = _interopRequireDefault(_is_wednesday);

var _is_thursday = require('date-fns/is_thursday');

var _is_thursday2 = _interopRequireDefault(_is_thursday);

var _is_friday = require('date-fns/is_friday');

var _is_friday2 = _interopRequireDefault(_is_friday);

var _is_saturday = require('date-fns/is_saturday');

var _is_saturday2 = _interopRequireDefault(_is_saturday);

var _is_sunday = require('date-fns/is_sunday');

var _is_sunday2 = _interopRequireDefault(_is_sunday);

var _get_iso_week = require('date-fns/get_iso_week');

var _get_iso_week2 = _interopRequireDefault(_get_iso_week);

var _date = require('../date');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var defaultTimeFormats = {
  A: 'YYYY',
  S: 'YYYY-[S][SEMESTER]',
  Q: 'YYYY-[Q]Q',
  M: 'YYYY-MMM',
  W: 'YYYY-[W]WW',
  B: 'YYYY-[W]WW',
  D: 'YYYY-MM-DD',
  H: 'YYYY-MM-DD[T]HH:mm:ss',
  N: 'YYYY-MM-DD[T]HH:mm:ss'
};

var getTimeProc = exports.getTimeProc = function getTimeProc(frequency) {
  var timeFormats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var locale = arguments[2];

  if (frequency === 'W' || frequency === 'B') {
    return function (datum) {
      var isoWeek = (0, _get_iso_week2.default)(datum);
      if (isoWeek !== 1) {
        return _dateFns2.default.format(datum, 'YYYY-[W]WW', { locale: (0, _date.getLocale)(locale) });
      }
      var seventhDay = _dateFns2.default.endOfWeek(datum, { weekStartsOn: 1 });
      return _dateFns2.default.format(seventhDay, 'YYYY-[W]WW', { locale: (0, _date.getLocale)(locale) });
    };
  }
  var format = R.pipe(R.mergeRight(defaultTimeFormats), R.ifElse(R.has(frequency), R.prop(frequency), R.prop('A')))(timeFormats);
  return function (datum) {
    return _dateFns2.default.format((0, _date.dateWithoutTZ)(new Date(datum)), format, { locale: (0, _date.getLocale)(locale) });
  };
};

var getTimeFrequency = function getTimeFrequency(data) {
  var frequency = R.prop('frequency', data);
  if (frequency === 'W' || frequency === 'B') {
    var date = R.pathOr(['series', 0, 'datapoints', 'x']);
    return R.cond([[_is_monday2.default, R.always('monday')], [_is_tuesday2.default, R.always('tueday')], [_is_wednesday2.default, R.always('wednesday')], [_is_thursday2.default, R.always('thursday')], [_is_friday2.default, R.always('friday')], [_is_saturday2.default, R.always('saturday')], [_is_sunday2.default, R.always('sunday')], [R.T, R.always('monday')]])(date);
  }
  return R.cond([[R.equals('A'), R.always('year')], [R.equals('S'), R.always('month')], [R.equals('Q'), R.always('month')], [R.equals('M'), R.always('month')], [R.equals('D'), R.always('day')], [R.equals('H'), R.always('hour')], [R.equals('N'), R.always('minute')], [R.T, R.always('year')]])(frequency);
};

var getTimeStep = R.cond([[R.equals('A'), R.always(1)], [R.equals('S'), R.always(6)], [R.equals('Q'), R.always(3)], [R.equals('M'), R.always(1)], [R.equals('W'), R.always(1)], [R.equals('B'), R.always(1)], [R.equals('D'), R.always(1)], [R.equals('H'), R.always(1)], [R.equals('N'), R.always(1)], [R.T, R.always(1)]]);

var getAxisOptions = exports.getAxisOptions = function getAxisOptions(data, type, options, timeFormats, locale) {

  var axis = {
    linear: { pivot: { color: 'white' } },
    ordinal: { gap: .3, padding: .3 },
    thickness: 0
  };

  var linearProc = function linearProc(d) {
    return (0, _numeral2.default)(d).format('0,0.[00]');
  };

  return R.pipe(R.propOr({}, 'axis'), R.mergeDeepRight({ x: axis, y: axis }), R.cond([[R.always(R.equals(_constants.BAR, type)), R.pipe(R.mergeDeepRight({
    x: { format: { proc: R.identity }, tick: { thickness: 0, size: 0 } },
    y: {
      font: { baseline: 'ideographic' },
      format: { proc: linearProc },
      padding: 10,
      tick: { thickness: 0 }
    }
  }), R.over(R.lensPath(['y', 'linear', 'pivot', 'value']), R.when(R.isNil, R.always(0))))], [R.always(R.equals(_constants.ROW, type)), R.pipe(R.mergeDeepRight({
    x: {
      format: { proc: linearProc },
      orient: 'top',
      padding: 10,
      tick: { thickness: 0 }
    },
    y: {
      format: { proc: R.identity },
      ordinal: { minDisplaySize: 300 },
      tick: { thickness: 0, size: 0 }
    }
  }), R.over(R.lensPath(['x', 'linear', 'pivot', 'value']), R.when(R.isNil, R.always(0))))], [R.always(R.equals(_constants.SCATTER, type)), R.mergeDeepRight({
    x: {
      format: { proc: linearProc },
      tick: { thickness: 0, size: 0 }
    },
    y: {
      font: { baseline: 'ideographic' },
      format: { proc: linearProc },
      padding: 10,
      tick: { thickness: 0 }
    }
  })], [R.always(R.equals(_constants.TIMELINE, type)), R.pipe(R.mergeDeepRight({
    x: {
      format: {
        isTime: true,
        pattern: null,
        proc: getTimeProc(R.prop('frequency', data), timeFormats, locale)
      },
      tick: { size: -6, minorSize: -3, thickness: 2, minorThickness: 2, color: 'white' }
    },
    y: {
      font: { baseline: 'ideographic' },
      format: { proc: function proc(d) {
          return (0, _numeral2.default)(d).format('0,0.[00]');
        } },
      padding: 10,
      tick: { thickness: 0 }
    }
  }), R.evolve({
    x: R.pipe(R.set(R.lensPath(['linear', 'frequency']), getTimeFrequency(data)), R.set(R.lensPath(['linear', 'step']), getTimeStep(R.prop('frequency', data))), R.over(R.lensPath(['tick', 'step']), R.pipe(R.when(R.isNil, R.always(1)), R.multiply(getTimeStep(R.prop('frequency', data))))))
  }))], [R.always(R.equals(_constants.H_SYMBOL, type)), R.mergeDeepRight({
    x: {
      format: { proc: linearProc },
      orient: 'top',
      padding: 10,
      tick: { thickness: 0 }
    },
    y: {
      format: { proc: R.identity },
      ordinal: { minDisplaySize: 300 },
      tick: { thickness: 0, size: 5 }
    }
  })], [R.always(R.equals(_constants.V_SYMBOL, type)), R.mergeDeepRight({
    x: { format: { proc: R.identity }, tick: { thickness: 0, size: 0 } },
    y: {
      font: { baseline: 'ideographic' },
      format: { proc: linearProc },
      padding: 10,
      tick: { thickness: 0 }
    }
  })], [R.always(R.equals(_constants.STACKED_BAR, type)), R.pipe(R.mergeDeepRight({
    x: { format: { proc: R.identity }, tick: { thickness: 0, size: 0 } },
    y: {
      font: { baseline: 'ideographic' },
      format: { proc: linearProc },
      padding: 10,
      tick: { thickness: 0 }
    }
  }), R.over(R.lensPath(['y', 'linear', 'pivot', 'value']), R.when(R.isNil, R.always(0))))], [R.always(R.equals(_constants.STACKED_ROW, type)), R.pipe(R.mergeDeepRight({
    x: {
      format: { proc: linearProc },
      orient: 'top',
      padding: 10,
      tick: { thickness: 0 }
    },
    y: {
      format: { proc: R.identity },
      ordinal: { minDisplaySize: 300 },
      tick: { thickness: 0, size: 0 }
    }
  }), R.over(R.lensPath(['x', 'linear', 'pivot', 'value']), R.when(R.isNil, R.always(0))))], [R.T, R.identity]]))(options);
};